// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * Drag- and keyboard-resize for the right-docked Ask Helios panel: the shared
 * `useDockedPanelResize` gesture bound to this panel's width, bounds and CSS
 * variable. The Asset Details panel binds the same hook to its own.
 */

import { ASK_HELIOS_MAX_WIDTH, ASK_HELIOS_MIN_WIDTH, useShellStore } from '../stores/shellStore';
import { useDockedPanelResize, type UseDockedPanelResizeResult } from './useDockedPanelResize';

/** The CSS variable both the panel and the offset asset panel read. */
export const ASK_HELIOS_WIDTH_VAR = '--ask-helios-width';

export type UseAskHeliosResizeResult = UseDockedPanelResizeResult;

export const useAskHeliosResize = (): UseAskHeliosResizeResult =>
  useDockedPanelResize({
    widthVar: ASK_HELIOS_WIDTH_VAR,
    width: useShellStore(s => s.askHeliosWidth),
    setWidth: useShellStore(s => s.setAskHeliosWidth),
    minWidth: ASK_HELIOS_MIN_WIDTH,
    maxWidth: ASK_HELIOS_MAX_WIDTH,
    label: 'Resize Ask EnergyFluo panel',
  });
